var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconSocialInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M18.5 0h-13A5.51 5.51 0 0 0 0 5.5v13A5.51 5.51 0 0 0 5.5 24h13a5.51 5.51 0 0 0 5.5-5.5v-13A5.51 5.51 0 0 0 18.5 0M20 16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 7,
  r: 1
}))));
export default SvgStreamlineIconSocialInstagram;